
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Label } from "../../../../components/Form";

export default {
  name: "Select",
  components: {
    VueSelect,
    Label,
  },
  props: {
    busca: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    placeholderInField: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
    },
    labelBusca: {
      type: String,
    },
    refBusca: {
      type: String,
    },
    inputClass: {
      type: String,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    change: {
      type: Function,
      required: true,
    },
    search: {
      type: Function,
      required: true,
    },
    options: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  methods: {
    handleChange(selected) {
      this.change(selected);
    },
    handleSearch(search, loading) {
      this.search(search, loading);
    },
  },
};
